/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// HELPERS
import dotenv from 'dotenv';
import moment from 'moment';

// REDUX
import { connect } from 'react-redux';
import * as elementsActions from '../../redux/actions/elements';
import {
  getQuarterRange,
  getYearRange,
  getLastYearRange,
} from '../../util/util';

import styles from './Filter.module.scss';

dotenv.config();

const dropDownIcon = require('./imgs/dropdown-icon.svg');

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      section: 'My Business',
    };
  }

  componentDidMount() {
    setTimeout(
      () => window.addEventListener('scroll', this.handleStickyListener),
      100
    ); // eslint-disable-line
  }

  /**
   * Returns filter component period range based on argument types
   * @param {boolean} year
   * @param {boolean} last
   */
  returnPeriodRange = (year, last) => {
    const rangeType = year ? 'year' : 'quarter';
    const start = moment()
      .startOf(rangeType)
      .subtract(last ? 1 : 0, rangeType)
      .format('D MMM YYYY');
    const end = moment()
      .endOf(rangeType)
      .subtract(last ? 1 : 0, rangeType)
      .format('D MMM YYYY');
    return `${start} - ${end}`;
  };

  /**
   * Handles filter sticky listener & component copy logic
   */
  handleStickyListener = () => {
    const { setStickyFilter, stickyFilter, marketViewPosition } = this.props;
    const scrollY = window.pageYOffset; // eslint-disable-line
    if (scrollY >= 75 && !stickyFilter) setStickyFilter(true);
    if (scrollY <= 75 && stickyFilter) setStickyFilter(false);
    this.setState({
      section:
        scrollY > marketViewPosition - 50 ? 'Market View' : 'My Business',
    });
  };

  /**
   * Returns fully formatted options array
   * @param {String} title
   * @param {String} value
   * @param {Array} options
   * @return {React.Components} returns fully formatted react elements
   */
  returnOptions = (title, value, options) => {
    const optionsToRender = options.length > 4 ? options.slice(0, 4) : options;

    return (
      <div className={styles.optionsContainer}>
        <p className={styles.rowTitle}>{title}</p>
        <div className={styles.rowWrapper}>
          <div style={{ width: options.length * 125 }}>
            {optionsToRender.map((option) => {
              const { filterObject, setFilterObject } = this.props;
              const isChosen =
                value === 'viewBy'
                  ? filterObject[value] === option.value
                  : filterObject[value].name === option.name; // eslint-disable-line
              return (
                <p
                  key={option.name}
                  onClick={() => {
                    if (value === 'viewBy') {
                      return setFilterObject({
                        ...filterObject,
                        [value]: option.value,
                      });
                    }

                    return setFilterObject({
                      ...filterObject,
                      [value]: option,
                    });
                  }}
                  className={isChosen ? styles.isChosen : null}
                >
                  {option.name}
                </p>
              );
            })}
            {options.length > 4 ? (
              <span className={styles.viewAll}>
                <a href="/feature">View All</a>
                <img alt="arrow" src={dropDownIcon} />
              </span>
            ) : undefined}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { showMenu, section } = this.state;
    const { isStatic, filterObject, allPortfolioFilters } = this.props;
    const { portfolio, timePeriod } = filterObject;
    return (
      <>
        <div
          style={{
            backgroundColor: showMenu && isStatic ? '#FFF' : null,
            paddingBottom: showMenu && isStatic ? 35 : null,
            borderBottom: showMenu && isStatic ? '1px solid #E0E0E0' : null,
          }}
          className={
            isStatic ? styles.staticFilterWrapper : styles.filterWrapper
          }
        >
          {/* MAIN FILTER CONTAINER */}
          <div className={isStatic ? styles.staticHeader : styles.filterHeader}>
            {isStatic ? <div /> : null}
            {isStatic ? <p>My Business</p> : <p>{section}</p>}
          </div>
          <div
            onClick={() => this.setState({ showMenu: !showMenu })}
            className={
              isStatic ? styles.staticFilterOptions : styles.filterOptions
            }
          >
            <div>
              <div>
                <p>{portfolio.name}</p>
                {isStatic ? (
                  <img
                    className={showMenu ? styles.activeDropDown : null}
                    alt="dropdown"
                    src={dropDownIcon}
                  />
                ) : null}
              </div>
              <div>
                <p>{timePeriod.name}</p>
                {!isStatic ? (
                  <img
                    className={showMenu ? styles.activeDropDown : null}
                    alt="dropdown"
                    src={dropDownIcon}
                  />
                ) : null}
                {isStatic ? (
                  <span>
                    {this.returnPeriodRange(
                      timePeriod.name.includes('Year'),
                      timePeriod.name.includes('Last')
                    )}
                  </span>
                ) : null}
              </div>
            </div>
            {!isStatic ? (
              <span>
                {this.returnPeriodRange(
                  timePeriod.name.includes('Year'),
                  timePeriod.name.includes('Last')
                )}
              </span>
            ) : null}
          </div>
        </div>
        {showMenu ? (
          <div
            className={
              isStatic ? styles.staticOptionsWrapper : styles.optionsWrapper
            }
          >
            {/* TODO: GET PORTFOLIO ARRAY DATA FROM GRAPHQL QUERY */}
            {allPortfolioFilters && allPortfolioFilters.length > 0
              ? this.returnOptions(
                  'PORTFOLIO',
                  'portfolio',
                  allPortfolioFilters
                )
              : undefined}
            {this.returnOptions('TIME PERIOD', 'timePeriod', [
              {
                name: 'This Quarter',
                ...getQuarterRange(moment().quarter()),
              },
              {
                name: 'This Year',
                ...getYearRange(),
              },
              {
                name: 'Last Quarter',
                ...getQuarterRange(moment().quarter() - 1),
              },
              { name: 'Last Year', ...getLastYearRange() },
            ])}
            {this.returnOptions('VIEW BY', 'viewBy', [
              { name: 'Manufacturer', value: 'manufacturer' },
              { name: 'Brand', value: 'brand' },
              { name: 'Product Group', value: 'client_product_group' },
              { name: 'Category', value: 'category' },
              { name: 'Subcategory', value: 'subcategory' },
            ])}
          </div>
        ) : null}
        {/* { showMenu && !isStatic ? (<div className={styles.filterOverlay} />) : null} */}
      </>
    );
  }
}

Filter.propTypes = {
  isStatic: PropTypes.bool,
  setStickyFilter: PropTypes.func.isRequired,
  marketViewPosition: PropTypes.number,
  stickyFilter: PropTypes.bool,
  filterObject: PropTypes.shape({
    portfolio: {
      name: PropTypes.string.isRequired,
      uuid: PropTypes.string.isRequired,
    },
    timePeriod: {
      name: PropTypes.string.isRequired,
      start: PropTypes.string.isRequired,
      end: PropTypes.string.isRequired,
    },
    viewBy: PropTypes.string.isRequired,
  }).isRequired,
  setFilterObject: PropTypes.func.isRequired,
  allPortfolioFilters: [].isRequired,
};

Filter.defaultProps = {
  isStatic: false,
  stickyFilter: false,
  marketViewPosition: 0,
};

const mapStateToProps = (state) => {
  const {
    stickyFilter,
    marketViewPosition,
    filterObject,
    allPortfolioFilters,
  } = state.elements;
  return {
    stickyFilter,
    marketViewPosition,
    filterObject,
    allPortfolioFilters,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setStickyFilter: (value) => dispatch(elementsActions.setStickyFilter(value)),
  setFilterObject: (value) => dispatch(elementsActions.setFilterObject(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
